import { loggingContexts } from "../../root/modules/logs/data/logging-contexts.js";
import { log } from "../../root/modules/logs/log.js";
import { useMainStore } from "../store/mainStore.js";
import { isPreviousAlertWindowForCaseOpen } from "./is-previous-alert-window-for-case-open.js";

const alertLog = log(loggingContexts.alert);

export const alert = async ({ alertID, caseID }) => {
  const mainStore = useMainStore();

  const url = `/alert?alertID=${alertID}&caseID=${caseID}`;

  const height = 450;
  const width = 1016;

  const previousAlertWindowForCaseIsOpen =
    await isPreviousAlertWindowForCaseOpen({ alertID, caseID });

  mainStore.caseTracker[caseID] = mainStore.caseTracker[caseID] || {};

  if (mainStore.caseTracker[caseID].silenced === true) {
    alertLog.info("this case is silenced", {
      caseID,
      caseNumber: mainStore.caseTracker[caseID].caseNumber,
    });

    return;
  }

  mainStore.caseTracker[caseID].wasOpen = previousAlertWindowForCaseIsOpen;

  if (window.api?.openAlertWindow) {
    window.api.openAlertWindow({ alertID, caseID, height, url, width });
  } else {
    window.open(url, caseID, `height=${height},width=${width}`);
  }
};
